

import { ButtonAction } from "./ButtonAction";
import { ButtonActionsRoot } from "./ButtonActionsRoot";
import { ButtonContainerLeft } from "./ButtonContainerLeft";
import { ButtonContainerRight } from "./ButtonContainerRight";
import { ButtonIcon } from "./ButtonIcon";


export const ButtonsActions = {
    Root: ButtonActionsRoot,
    Action: ButtonAction,
    ContainerLeft: ButtonContainerLeft,
    ContainerRight: ButtonContainerRight,
    Icon: ButtonIcon,
}
